import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import posthog from 'posthog-js';
import { filter } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class PosthogTrackingService {
  constructor(private router: Router) {
    this.trackPageViews();
  }

  trackPageViews() {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        posthog.capture('$pageview', {
          url: event.urlAfterRedirects
        });
      });
  }
}
